import React from 'react';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';

import AccodionFAQ from "../../../component/AccodionFAQ";

const useStyles = makeStyles(theme => ({
    accordionWrapper: {
        backgroundColor: theme.palette.grey['100'],
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(5),
    },
    accordion: {
        marginLeft: '15%',
        marginRight: '15%',
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10%',
            marginRight: '10%',
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: '5%',
            marginRight: '5%',
        },
    },
    accordionTitle: {
        fontSize: 28,
        fontWeight: 500,
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        marginLeft: '15%',
        marginRight: '15%',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
        },
    },
}));

const BusinessDetailsFAQ = () =>{
    const classes = useStyles();
    const faqRef = React.useRef();
    const { pathname, hash } = useLocation();
    React.useEffect(() => {
        if (hash === '#faq') window.scrollTo(0, faqRef.current.offsetTop)
    }, [pathname])

    return(
        <div className={classes.accordionWrapper}>
            <div className={classes.accordion}>
                <p
                    className={classes.accordionTitle}
                    id="faq"
                    ref={faqRef}
                >
                    Frequently Asked Questions
                </p>

                <AccodionFAQ
                    question={'How does the real-time tracking work?'}
                    answer={`Every parcel delivered by us is geo-tagged and
                            assigned a unique code. Whenever the parcel is
                            picked up by one of our delivery partners it
                            sends its location to our secure servers. The
                            location is constantly updated and is available
                            to both you and your customers. To see the
                            current location of a parcel, go to 'My Parcels'
                            in the menu and select the parcel. The location
                            will appear on the map.`}
                />

                <AccodionFAQ
                    question={'How do I know that my parcel was delivered?'}
                    answer={`Parcels are only delivered to the customer
                    provided address and left with the customer or a
                    member of the household. If special instructions
                    are provided to leave the parcel at a secure
                    location, we take pictures of the delivery and
                    capture the exact GPS coordinates to confirm the
                    parcel was delivered as instructed.`}
                />

                <AccodionFAQ
                    question={'What if the customer is not at home?'}
                    answer={`We can leave the parcel at a secure location or
                    with a neighbour if the customer has provided
                    this information in the delivery instructions.
                    Any undelivered parcels are left at a secure
                    collection point for the customer to collect.`}
                />

                <AccodionFAQ
                    question={'How can I reduce my delivery cost even further?'}
                    answer={`Using a collection point as the delivery address
                    can reduce parcel costs. We have a number of
                    collection points across the country for your
                    customer convenience`}
                />
            </div>
            </div>
    )
}

export default BusinessDetailsFAQ;